import { useEffect, useState } from "react";
import { useAuthStore } from "../store/useAuthStore";
import { useClientStore } from "../store/useClientStore";
import ClientList from "../components/clients/ClientList";
import ClientForm from "../components/clients/ClientForm";
import { Plus, Users } from "lucide-react";
import toast from "react-hot-toast";

const ClientPage = () => {
  const { authUser } = useAuthStore();
  const { fetchClients } = useClientStore();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    if (authUser?._id) fetchClients();
  }, [authUser]);

  const isBD = authUser?.role === "Business Developer";

  return (
    <div className={`min-h-screen bg-background px-4 lg:px-8 pb-10 ${isBD ? "pt-8" : "pt-20"}`}>
      <div className="max-w-[1400px] mx-auto flex flex-col gap-6">

        <section className="bg-surface-container-lowest rounded-xl border border-outline-variant card-shadow p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-[26px] font-bold text-on-surface tracking-tight flex items-center gap-2"><Users className="text-primary" size={24} /> Contacts</h1>
            <p className="text-[14px] text-on-surface-variant mt-1">
              Add, edit, and organize your client contacts
            </p>
          </div>
          <button
            onClick={() => setDrawerOpen(true)}
            className="bg-primary text-white text-sm font-semibold px-5 py-2.5 rounded-lg flex items-center gap-2 hover:bg-[#004b9e] transition-colors shrink-0"
          >
            <Plus size={18} /> Add New Contact
          </button>
        </section>

        <section className="bg-surface-container-lowest rounded-xl border border-outline-variant card-shadow p-4 lg:p-6">
          <ClientList />
        </section>

        <div
          className={`fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${
            drawerOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >

          <div className="flex items-center justify-between p-6 border-b bg-gray-50">
            <h2 className="text-xl font-semibold text-gray-800">Add New Contact</h2>
            <button
              onClick={() => setDrawerOpen(false)}
              className="p-1.5 rounded-full hover:bg-gray-200 transition"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="overflow-y-auto h-[calc(100%-5rem)] p-6">
            <ClientForm
              onSuccess={() => setDrawerOpen(false)}
              onCredentialsReady={(name, email, password) => {
                const text = `Name: ${name}\nEmail: ${email}\nPassword: ${password}`;
                navigator.clipboard.writeText(text).then(() => {
                  toast.success("Credentials copied!");
                });
                setDrawerOpen(false);
              }}
            />
          </div>
        </div>

        {drawerOpen && (
          <div
            onClick={() => setDrawerOpen(false)}
            className="fixed inset-0 bg-black/30 z-40"
          />
        )}

        <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
          <div className="absolute top-20 -left-20 w-72 h-72 bg-[#2462b2]/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 -right-20 w-80 h-80 bg-[#2462b2]/5 rounded-full blur-3xl"></div>
        </div>
      </div>
    </div>
  );
};

export default ClientPage;
